
(function initSearchModal() {
  'use strict';

  var root = document.getElementById('TruSearchModal');
  if (!root) return;

  var screen     = root.querySelector('[data-sm-screen]');
  var form       = root.querySelector('[data-sm-form]');
  var input      = root.querySelector('[data-sm-input]');
  var closeBtn   = root.querySelector('[data-sm-close]');
  var results    = root.querySelector('[data-sm-results]');
  var emptyPanel = root.querySelector('[data-sm-empty]');
  var recsEl     = root.querySelector('[data-sm-recs]');
  var recsTrack  = root.querySelector('[data-sm-recs-track]');
  var recsOverflow = root.querySelector('[data-sm-recs-overflow]');
  var recsPrev   = root.querySelector('[data-sm-recs-prev]');
  var recsNext   = root.querySelector('[data-sm-recs-next]');

  var EXCLUDE_SUBSTRINGS = ['redo', 'bogo', 'freebie', 'free-gift', 'free-return', 'bundler', 'insurance'];

  // Curated "Pages" list — Bundle builder pinned first, then whatever
  // pdp_link blocks the merchant added in the theme editor (see
  // sections/search-modal.liquid). Static and query-independent on purpose:
  // it replaces Shopify's predictive-search page matches, which could
  // surface any unrelated page.
  var PDP_LINKS = (function () {
    var el = document.getElementById('TruSearchPdpLinks');
    if (!el) return [{ title: 'Bundle builder', url: '/pages/bundle-builder' }];
    try {
      var parsed = JSON.parse(el.textContent);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [{ title: 'Bundle builder', url: '/pages/bundle-builder' }];
    }
  })();

  /* ── Helpers ──
     window.themeCurrency is NOT actually global in this theme (it's a
     module-scope variable inside the bundled theme.js closure), so we
     can't call into it from a standalone script. This is a self-contained
     port of Shopify's standard theme-currency formatMoney: pass a decimal
     string like "49.99" (as returned by /search/suggest.json) and it strips
     the dot before treating it as cents; pass a real integer cents value
     (as returned by /recommendations/products.json) and it's used as-is. */
  function formatMoney(price) {
    var cents = price;
    if (typeof cents === 'string') cents = cents.replace('.', '');

    var format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function withDelimiters(number, precision, thousands, decimalSep) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimalSep = decimalSep == null ? '.' : decimalSep;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var decimals = parts[1] ? decimalSep + parts[1] : '';
      return dollars + decimals;
    }

    var match = format.match(placeholderRegex);
    var kind = match ? match[1] : 'amount';
    var value;
    switch (kind) {
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ''); break;
      case 'amount_with_period_and_space_separator': value = withDelimiters(cents, 2, ' ', '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return match ? format.replace(placeholderRegex, value) : '$' + value;
  }

  function getSizedImageUrl(url, size) {
    if (!url) return url;
    if (url.match(/_(pico|icon|thumb|small|compact|medium|large|grande|original|master)\./)) {
      return url.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|master)\./, '_' + size + '.');
    }
    return url.replace(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?.*)?$/i, function (match, ext, query) {
      return '_' + size + '.' + ext + (query || '');
    });
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  // Some collection/page/article titles in this store's data contain raw
  // HTML (e.g. a page titled "<p><center><strong>Join The Family</strong>...").
  // Strip tags before escaping so results show clean plain text instead of
  // literal "<p><center>" showing up on screen.
  function cleanTitle(str) {
    return escapeHtml((str || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim());
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(null, args); }, wait);
    };
  }

  function isExcludedProduct(product) {
    var handle = (product.handle || '').toLowerCase();
    var title = (product.title || '').toLowerCase();
    var tags = (product.tags || []).join(' ').toLowerCase();
    if (title.indexOf('free returns') === 0) return true;
    return EXCLUDE_SUBSTRINGS.some(function (needle) {
      return handle.indexOf(needle) !== -1 || tags.indexOf(needle) !== -1;
    });
  }

  /* ── Open / close ── */
  var hasOpenedOnce = false;

  function openModal() {
    var openDrawer = document.querySelector('[data-drawer].drawer--visible');
    if (openDrawer) {
      openDrawer.dispatchEvent(new CustomEvent('theme:drawer:close', { bubbles: false }));
    }
    root.classList.add('is-active');
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('sm-overflow-hidden');
    root.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true }));
    setTimeout(function () { input.focus(); }, 150);

    var term = input.value.trim();
    if (term) {
      hideEmpty();
      fetchResults(term);
    } else {
      showEmpty();
      loadRecommendations();
    }
    hasOpenedOnce = true;
  }

  function closeModal() {
    root.classList.remove('is-active');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('sm-overflow-hidden');
    root.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
  }

  document.querySelectorAll('[data-sm-toggle]').forEach(function (trigger) {
    trigger.addEventListener('click', function (evt) {
      evt.preventDefault();
      openModal();
    });
  });

  if (closeBtn) closeBtn.addEventListener('click', function (evt) { evt.preventDefault(); closeModal(); });
  if (screen) screen.addEventListener('click', closeModal);
  if (form) form.addEventListener('submit', function (evt) {
    if (!input.value.trim()) evt.preventDefault();
  });

  document.addEventListener('keydown', function (evt) {
    if ((evt.key === 'Escape' || evt.keyCode === 27) && root.classList.contains('is-active')) {
      closeModal();
    }
  });

  /* ── Live results ── */
  function showEmpty() {
    if (emptyPanel) emptyPanel.classList.add('is-visible');
  }
  function hideEmpty() {
    if (emptyPanel) emptyPanel.classList.remove('is-visible');
  }
  function clearInjectedResults() {
    Array.prototype.slice.call(results.children).forEach(function (child) {
      if (!child.hasAttribute('data-sm-empty')) child.remove();
    });
  }

  function buildResourceTypes() {
    var s = (window.theme && window.theme.settings) || {};
    var parts = [];
    if (s.search_products !== false) parts.push('product');
    if (s.search_collections) parts.push('collection');
    if (s.search_pages) parts.push('page');
    if (s.search_articles) parts.push('article');
    return parts.join(',');
  }

  var onInput = debounce(function () {
    var term = input.value.trim();
    clearInjectedResults();
    if (!term) {
      showEmpty();
      return;
    }
    hideEmpty();
    fetchResults(term);
  }, 300);

  input.addEventListener('input', onInput);

  function fetchResults(term) {
    var url = '/search/suggest.json?q=' + encodeURIComponent(term) +
      '&resources[type]=' + buildResourceTypes() +
      '&resources[limit]=8&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=last';

    fetch(url)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data) return;
        renderResults(data.resources.results, term);
      })
      .catch(function () {});
  }

  function renderResults(res, term) {
    clearInjectedResults();

    var products = res.products || [];
    var collections = res.collections || [];
    var queries = res.queries || [];

    var hasAny = products.length || collections.length;

    var wrap = document.createElement('div');
    wrap.className = 'sm-results-inner';

    if (!hasAny) {
      wrap.innerHTML =
        '<div class="sm-no-results">' +
          '<p class="sm-no-results__text">No results found for &ldquo;' + escapeHtml(term) + '&rdquo;</p>' +
          '<a class="sm-no-results__link" href="/search?q=' + encodeURIComponent(term) + '">' +
            'View all results' +
          '</a>' +
        '</div>' +
        buildPagesBlock();
      results.insertBefore(wrap, results.firstChild);
      // Fall back to the same badges/recs panel shown in the idle state, so a
      // dead-end query still leaves the visitor with somewhere to go.
      showEmpty();
      loadRecommendations();
      return;
    }

    hideEmpty();

    var group1 = buildOtherGroup(queries, collections);
    var group2 = buildProductGroup(products);

    wrap.innerHTML =
      '<div class="sm-results">' +
        '<div class="sm-results__group-1">' + group1 + '</div>' +
        '<div class="sm-results__group-2">' + group2 +
          '<button type="button" class="sm-results__search-btn" data-sm-view-all>' +
            '<span>View all results for &ldquo;' + escapeHtml(term) + '&rdquo;</span>' +
            '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>' +
          '</button>' +
        '</div>' +
      '</div>';

    results.insertBefore(wrap, results.firstChild);

    var viewAllBtn = wrap.querySelector('[data-sm-view-all]');
    if (viewAllBtn) {
      viewAllBtn.addEventListener('click', function () {
        window.location.href = '/search?q=' + encodeURIComponent(term);
      });
    }
  }

  function buildOtherGroup(queries, collections) {
    var html = '';
    if (queries.length) {
      html += '<div class="sm-results__block sm-results--queries"><h4 class="h4">Suggestions</h4><ul role="listbox">';
      queries.forEach(function (q) {
        html += '<li role="option"><a href="' + q.url + '">' + (q.styled_text || escapeHtml(q.text)) + '</a></li>';
      });
      html += '</ul></div>';
    }
    if (collections.length) {
      html += '<div class="sm-results__block sm-results--collections"><h4 class="h4">Collections</h4><ul role="listbox">';
      collections.forEach(function (c) {
        html += '<li role="option"><a href="' + c.url + '">' + cleanTitle(c.title) + '</a></li>';
      });
      html += '</ul></div>';
    }
    html += buildPagesBlock();
    return html;
  }

  function buildPagesBlock() {
    if (!PDP_LINKS.length) return '';
    var html = '<div class="sm-results__block sm-results--pages" style="margin-top:12px"><h4 class="h4">Pages</h4><ul role="listbox">';
    PDP_LINKS.forEach(function (p) {
      html += '<li role="option"><a href="' + p.url + '">' + cleanTitle(p.title) + '</a></li>';
    });
    html += '</ul></div>';
    return html;
  }

  function buildProductGroup(products) {
    if (!products.length) return '<div class="sm-results--no-products"><p class="sm-no-products">No matching products.</p></div>';

    var html = '<div class="sm-results__block sm-results--products"><h4 class="h4">Products</h4><ul role="listbox">';
    products.forEach(function (product) {
      var price = parseFloat(product.price_min || product.price);
      var comparePrice = parseFloat(product.compare_at_price_min);
      var onSale = comparePrice > 0 && comparePrice > price;
      var thumb = product.featured_image ? getSizedImageUrl(product.featured_image.url, '160x160') : '';

      html += '<li role="option"><a href="' + product.url + '" class="sm-product">' +
        '<div class="sm-product__image">' +
          (thumb ? '<img src="' + thumb + '" alt="' + cleanTitle(product.featured_image.alt || product.title) + '" width="80" height="80" loading="lazy">' : '') +
        '</div>' +
        '<div class="sm-product__info">' +
          '<span class="sm-product__title">' + cleanTitle(product.title) + '</span>' +
          '<span class="sm-product__price-row">' +
            '<span class="sm-product__price' + (onSale ? ' is-sale' : '') + '">' + formatMoney(product.price_min || product.price) + '</span>' +
            (onSale ? '<span class="sm-product__compare">' + formatMoney(product.compare_at_price_min) + '</span>' : '') +
            (!product.available ? '<span class="sm-product__sold-out">Sold out</span>' : '') +
          '</span>' +
        '</div>' +
      '</a></li>';
    });
    html += '</ul></div>';
    return html;
  }

  /* ── Empty-state recommendations carousel ── */
  var recsLoaded = false;

  function loadRecommendations() {
    if (recsLoaded || !recsEl) return;

    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var productId = (cart.items && cart.items[0] && cart.items[0].product_id) ||
          recsEl.getAttribute('data-sm-fallback-product-id');
        if (!productId) return;
        return fetchAndRenderRecs(productId);
      })
      .catch(function () {
        var fallbackId = recsEl.getAttribute('data-sm-fallback-product-id');
        if (fallbackId) fetchAndRenderRecs(fallbackId);
      });
  }

  function fetchAndRenderRecs(productId) {
    return fetch('/recommendations/products.json?product_id=' + productId + '&limit=10&intent=related')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !data.products || !data.products.length) return;
        var products = data.products.filter(function (p) { return !isExcludedProduct(p); });
        if (!products.length) return;
        renderRecommendations(products);
        recsLoaded = true;
      })
      .catch(function () {});
  }

  function renderRecommendations(products) {
    if (!recsTrack) return;
    recsTrack.innerHTML = '';

    products.forEach(function (product) {
      var variant = product.variants && product.variants[0];
      if (!variant) return;

      var price = variant.price;
      var compare = variant.compare_at_price;
      var imgSrc = product.featured_image || (product.images && product.images[0] && product.images[0].src);
      var title = product.title || '';
      var thumb = imgSrc ? getSizedImageUrl(imgSrc, '300x300') : '';

      var card = document.createElement('a');
      card.className = 'sm-rec-card';
      card.href = '/products/' + product.handle;
      card.innerHTML =
        '<div class="sm-rec-card__img-wrap">' +
          (thumb ? '<img class="sm-rec-card__img" src="' + thumb + '" alt="' + cleanTitle(title) + '" loading="lazy">' : '') +
        '</div>' +
        '<p class="sm-rec-card__title">' + cleanTitle(title) + '</p>' +
        '<div class="sm-rec-card__price-row">' +
          '<span class="sm-rec-card__price">' + formatMoney(price) + '</span>' +
          (compare && compare > price ? '<span class="sm-rec-card__compare">' + formatMoney(compare) + '</span>' : '') +
        '</div>';

      recsTrack.appendChild(card);
    });

    initRecsDrag();
  }

  function initRecsDrag() {
    if (!recsOverflow || !recsTrack) return;

    var current = 0;
    var isDragging = false;
    var startX = 0;
    var startPos = 0;
    var moved = 0;

    function maxScroll() {
      return Math.max(0, recsTrack.scrollWidth - recsOverflow.clientWidth);
    }
    function setPos(x) {
      current = Math.min(0, Math.max(-maxScroll(), x));
      recsTrack.style.transform = 'translate3d(' + current + 'px, 0, 0)';
    }

    function onDown(e) {
      isDragging = true;
      moved = 0;
      startX = e.type === 'touchstart' ? e.touches[0].clientX : e.clientX;
      startPos = current;
      recsTrack.classList.add('is-dragging');
    }
    function onMove(e) {
      if (!isDragging) return;
      var x = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX;
      var diff = x - startX;
      moved = Math.abs(diff);
      setPos(startPos + diff);
      if (moved > 5 && e.cancelable) e.preventDefault();
    }
    function onUp() {
      if (!isDragging) return;
      isDragging = false;
      recsTrack.classList.remove('is-dragging');
    }

    recsTrack.addEventListener('mousedown', onDown);
    recsTrack.addEventListener('touchstart', onDown, { passive: true });
    document.addEventListener('mousemove', onMove);
    document.addEventListener('touchmove', onMove, { passive: false });
    document.addEventListener('mouseup', onUp);
    document.addEventListener('touchend', onUp);

    // Ignore clicks that were actually drags
    recsTrack.addEventListener('click', function (e) {
      if (moved > 5) e.preventDefault();
    });

    function step(dir) {
      var cardWidth = recsTrack.firstElementChild ? recsTrack.firstElementChild.getBoundingClientRect().width + 12 : 160;
      setPos(current - dir * cardWidth);
    }

    if (recsPrev) recsPrev.addEventListener('click', function () { step(-1); });
    if (recsNext) recsNext.addEventListener('click', function () { step(1); });
  }

  // Prefetch immediately on script init (script runs deferred, right after
  // DOM parse) instead of waiting for the modal to open, so the carousel is
  // already rendered (recsLoaded = true) by the time the visitor opens the
  // modal — openModal()'s loadRecommendations() call becomes a no-op in the
  // common case. No requestIdleCallback/setTimeout wrapper: those add a
  // fixed delay (up to 2s, or a flat 500ms on browsers without
  // requestIdleCallback e.g. Safari) that can be longer than the fetches
  // themselves, defeating the point of prefetching.
  loadRecommendations();
})();
